var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJacuzzi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34434 14.5617V12.3494M6.34434 14.5617V15.7221C6.34434 16.8266 7.23977 17.7221 8.34434 17.7221H9.08491C10.1895 17.7221 11.0849 16.8266 11.0849 15.7221V14.5617M6.34434 14.5617H4.92217M6.34434 12.3494H4.60613C3.99523 12.3494 3.5 12.8447 3.5 13.4556V13.4556C3.5 14.0665 3.99523 14.5617 4.60613 14.5617H4.92217M6.34434 12.3494H11.0849M11.0849 12.3494H19.1439C19.7548 12.3494 20.25 12.8447 20.25 13.4556V13.4556C20.25 14.0665 19.7548 14.5617 19.1439 14.5617H18.9858M11.0849 12.3494V14.5617M11.0849 14.5617H18.9858M3.5 20.8824H4.92217M20.25 20.8824H18.9858M4.92217 14.5617V20.8824M4.92217 20.8824H18.9858M18.9858 14.5617V20.8824M9.18868 3.50037C8.5566 4.13244 8.24057 5.39659 8.5566 6.34471C8.9081 7.39919 9.50472 7.92489 9.50472 8.87301C9.50472 9.67253 8.97799 10.2425 8.87264 10.4532M12.3491 3.50037C11.717 4.13244 11.4009 5.39659 11.717 6.34471C12.0685 7.39919 12.6651 7.92489 12.6651 8.87301C12.6651 9.67253 12.1384 10.2425 12.033 10.4532M15.5094 3.50037C14.8774 4.13244 14.5613 5.39659 14.8774 6.34471C15.2289 7.39919 15.8255 7.92489 15.8255 8.87301C15.8255 9.67253 15.2987 10.2425 15.1934 10.4532",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacuzzi);
export default __webpack_public_path__ + "static/media/jacuzzi.18d01dd2bbae64c557532dc08016b3cd.svg";
export { ForwardRef as ReactComponent };